import React, { useState, useEffect, useLayoutEffect } from 'react';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import SearchForm from './components/SearchForm/SearchForm';
import Searcher from './util/Searcher';
import Result from './components/Result/Result';

export const FilterStore = React.createContext({
  firstFetched: false
})

export default () => {
  const [filter, setFilter] = useState({
    firstFetched: false
  });

  const step = 10;

  const [end, setEnd] = useState(step);

  const [currentItems, setCurrentItems] = useState();
  const [itemsFound, setItemsFound] = useState(0);

  useEffect(() => {
    if (Object.keys(filter).length > 0) {
      Searcher.updateFilter(filter);
    }
  }, [filter]);

  const handleScroll = async () => {
    if (currentItems) {
      const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
      const body = document.body;
      const html = document.documentElement;
      const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
      const windowBottom = windowHeight + window.pageYOffset;
      if (windowBottom >= docHeight) {
        const newEnd = end + step;
        setEnd(newEnd);
  
        const { response } = (await Searcher.search(end + 1, step));
        setCurrentItems([
          ...currentItems,
          ...response.docs
        ]);
      }
    }
  }

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [currentItems]);

  const search = async () => {
    const { response } = (await Searcher.search(0, end));

    setCurrentItems(response.docs);
    setItemsFound(response.numFound);
    if (!filter.firstFetched) {
      setFilter({
        ...filter,
        firstFetched: true,
      });
    }
  }

  const actions = {
    changeGeneralSearch(searchString) {
      setFilter({
        ...filter,
        searchString: searchString
      })
    },

    changeEarthDate(fromDate, toDate) {
      setFilter({
        ...filter,
        fromDate: fromDate,
        toDate: toDate
      });
    },

    changeSol(fromSol, toSol) {
      setFilter({
        ...filter,
        fromSol: fromSol,
        toSol: toSol
      });
    },

    changeRovers(rovers) {
      setFilter({
        ...filter,
        rovers: rovers,
      });
    },
  }

  return (
    <FilterStore.Provider value={{ filter, actions }}>
      <div className="app">
        <Header />
        <SearchForm
          onSave={search}
        />
        {filter.firstFetched
          ? <Result foundItems={itemsFound} items={currentItems} />
          : null}
        <Footer />
      </div>
    </FilterStore.Provider>
  );
}

